import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentUserIsGuest: getCurrentUserIsGuest(state),
    userName: state.context.session.userName,
});

const mapDispatchToProps = {
    signOut,
};

export interface SignOutStyles {
    noButton: ButtonPresentationProps;
    yesButton: ButtonPresentationProps;
}

const signOutStyles: SignOutStyles = {
    noButton: {
        color: "white",
    },
    yesButton: {
        color: "primary.main",
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const SignOutWidget: React.FC<Props> = ({ userName, currentUserIsGuest, signOut, history }) => {
    React.useEffect(() => {
        if (!userName) {
            history.push("/SignIn");
        }
    });

    const signOutHandler = () => {
        signOut();
    };

    const redirectHandler = () => {
        history.push("/");
    };

    return (
        <StyledWrapper>
            <Typography variant="h4">Are you sure you would like to sign out?</Typography>
            <GridContainer>
                <GridItem width={1}>
                    <Button variant="secondary" onClick={signOutHandler} {...signOutStyles.yesButton}>
                        Yes
                    </Button>
                </GridItem>
                <GridItem width={1}>
                    <Button variant="primary" onClick={redirectHandler} {...signOutStyles.noButton}>
                        No
                    </Button>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(SignOutWidget)),
    definition: {
        group: "Testing",
        icon: "Row",
        fieldDefinitions: [],
    },
};

export default widgetModule;
